/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Link_Invalid_BodyInputs */

const en_login_link_invalid_body = /** @type {(inputs: Login_Link_Invalid_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This sign-in link has expired or was already used.`)
};

const de_login_link_invalid_body = /** @type {(inputs: Login_Link_Invalid_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Anmeldelink ist abgelaufen oder wurde schon verwendet.`)
};

/**
* | output |
* | --- |
* | "This sign-in link has expired or was already used." |
*
* @param {Login_Link_Invalid_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const login_link_invalid_body = /** @type {((inputs?: Login_Link_Invalid_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Link_Invalid_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_link_invalid_body(inputs)
	return en_login_link_invalid_body(inputs)
});